/* Barre latérale des filtres — rendu AJAX par la Section Rendering API */
(() => {
  if (window.__fsInit) return;
  window.__fsInit = true;

  const FORM_ID = 'FacetsSidebarForm';
  const root = () => document.querySelector('[data-fs-root]');
  let controller = null;

  const paramsFromForm = () => {
    const form = document.getElementById(FORM_ID);
    const params = new URLSearchParams();
    if (!form) return '';
    const sortDefault = document.querySelector(`select[name="sort_by"][form="${FORM_ID}"]`)?.dataset.default;
    for (const [key, value] of new FormData(form)) {
      if (value === '' || (key === 'sort_by' && value === sortDefault)) continue;
      params.append(key, value);
    }
    return params.toString();
  };

  async function render(query, push = true) {
    const el = root();
    if (!el) return;
    if (controller) controller.abort();
    controller = new AbortController();
    el.classList.add('is-loading');

    const url = `${location.pathname}?section_id=${el.dataset.sectionId}${query ? '&' + query : ''}`;
    let html;
    try {
      const res = await fetch(url, { signal: controller.signal });
      if (!res.ok) throw new Error(res.status);
      html = await res.text();
    } catch (err) {
      if (err.name === 'AbortError') return;
      location.href = `${location.pathname}${query ? '?' + query : ''}`;
      return;
    }

    const doc = new DOMParser().parseFromString(html, 'text/html');

    // Garder l'état ouvert/fermé des blocs, les « Voir plus » dépliés et le focus
    const openState = {};
    el.querySelectorAll('details[data-fs-key]').forEach((d) => { openState[d.dataset.fsKey] = d.open; });
    const expanded = [...el.querySelectorAll('.fs-opts.is-expanded')].map((u) => u.closest('details')?.dataset.fsKey);
    const focusedId = document.activeElement?.id;
    const focusedName = document.activeElement?.name;
    const focusedValue = document.activeElement?.value;

    doc.querySelectorAll('[data-fs-part]').forEach((part) => {
      const current = el.querySelector(`[data-fs-part="${part.dataset.fsPart}"]`);
      if (current) current.replaceWith(part);
    });

    el.querySelectorAll('details[data-fs-key]').forEach((d) => {
      const key = d.dataset.fsKey;
      if (key in openState) d.open = openState[key] || d.querySelector('input:checked') !== null;
      if (expanded.includes(key)) toggleMore(d.querySelector('[data-fs-more]'), true);
    });
    el.querySelectorAll('[data-fs-price]').forEach(paintRange);

    let toFocus = focusedId ? document.getElementById(focusedId) : null;
    if (!toFocus && focusedName) {
      toFocus = el.querySelector(`input[name="${CSS.escape(focusedName)}"][value="${CSS.escape(focusedValue || '')}"]`);
    }
    if (toFocus) toFocus.focus({ preventScroll: true });

    // Comme le thème : les <template> des cartes (achat rapide) sont rattachés à leur formulaire
    document.getElementById('CollectionProductGrid')?.querySelectorAll('template').forEach((tpl) => {
      tpl.closest('form')?.append(tpl.content.cloneNode(true));
    });

    el.classList.remove('is-loading');
    if (push) history.pushState({ fsQuery: query }, '', `${location.pathname}${query ? '?' + query : ''}`);
    document.dispatchEvent(new CustomEvent('facets:updated', { detail: { query } }));
  }

  // ----- Prix -----
  function paintRange(box) {
    const [a, b] = box.querySelectorAll('[data-fs-range]');
    const fill = box.querySelector('[data-fs-fill]');
    if (!a || !b || !fill) return;
    const max = parseFloat(box.dataset.max) || 1;
    const lo = Math.min(+a.value, +b.value);
    const hi = Math.max(+a.value, +b.value);
    fill.style.left = `${(lo / max) * 100}%`;
    fill.style.right = `${100 - (hi / max) * 100}%`;
  }

  function setPrice(box, lo, hi) {
    const max = parseFloat(box.dataset.max);
    const [inMin, inMax] = box.querySelectorAll('.fs-price__inputs input');
    inMin.value = lo != null && lo > 0 ? lo : '';
    inMax.value = hi != null && hi < max ? hi : '';
  }

  // ----- « Voir plus » -----
  function toggleMore(btn, force) {
    if (!btn) return;
    const list = btn.previousElementSibling;
    const open = force ?? !list.classList.contains('is-expanded');
    list.classList.toggle('is-expanded', open);
    btn.setAttribute('aria-expanded', open);
    btn.textContent = open ? btn.dataset.labelLess : btn.dataset.labelMore;
  }

  // ----- Tiroir mobile -----
  function setDrawer(open) {
    const el = root();
    if (!el) return;
    el.classList.toggle('is-drawer-open', open);
    document.documentElement.style.overflow = open ? 'hidden' : '';
    document.documentElement.classList.toggle('fs-drawer-open', open);
    el.querySelectorAll('[data-fs-open]').forEach((b) => b.setAttribute('aria-expanded', open));
    if (open) el.querySelector('.fs-sidebar .fs-close')?.focus();
    else el.querySelector('[data-fs-open]')?.focus({ preventScroll: true });
  }

  document.addEventListener('change', (e) => {
    const t = e.target;
    if (!t.closest('[data-fs-root]')) return;
    if (t.matches('[data-fs-range]')) {
      const box = t.closest('[data-fs-price]');
      const [a, b] = box.querySelectorAll('[data-fs-range]');
      setPrice(box, Math.min(+a.value, +b.value), Math.max(+a.value, +b.value));
      render(paramsFromForm());
      return;
    }
    if (t.form?.id === FORM_ID || t.getAttribute('form') === FORM_ID) render(paramsFromForm());
  });

  document.addEventListener('input', (e) => {
    const t = e.target;
    if (!t.matches('[data-fs-range]')) return;
    const box = t.closest('[data-fs-price]');
    const [a, b] = box.querySelectorAll('[data-fs-range]');
    const [inMin, inMax] = box.querySelectorAll('.fs-price__inputs input');
    inMin.value = Math.min(+a.value, +b.value);
    inMax.value = Math.max(+a.value, +b.value);
    paintRange(box);
  });

  document.addEventListener('submit', (e) => {
    if (e.target.id !== FORM_ID) return;
    e.preventDefault();
    render(paramsFromForm());
  });

  // ----- « Afficher X produits de plus » -----
  async function loadMore(btn) {
    const el = root();
    if (!el || btn.getAttribute('aria-disabled') === 'true') return;
    btn.setAttribute('aria-disabled', 'true');
    btn.classList.add('is-loading');
    const url = new URL(btn.href, location.origin);
    url.searchParams.set('section_id', el.dataset.sectionId);
    let doc;
    try {
      const res = await fetch(url);
      if (!res.ok) throw new Error(res.status);
      doc = new DOMParser().parseFromString(await res.text(), 'text/html');
    } catch (err) {
      location.href = btn.href;
      return;
    }
    const grid = document.getElementById('main-collection-product-grid');
    const cards = [...doc.querySelectorAll('#main-collection-product-grid > *')];
    grid.append(...cards);
    // Comme le thème : les <template> des cartes (achat rapide) sont rattachés à leur formulaire
    cards.forEach((card) => card.querySelectorAll('template').forEach((tpl) => {
      tpl.closest('form')?.append(tpl.content.cloneNode(true));
    }));
    ['[data-load-more-wrap]', '[data-load-more-pagination]'].forEach((sel) => {
      const next = doc.querySelector(sel);
      const cur = el.querySelector(sel);
      if (cur && next) cur.replaceWith(next);
    });
    // Le focus passe sur la première nouvelle carte pour les claviers et lecteurs d'écran
    cards[0]?.querySelector('a[href]')?.focus({ preventScroll: true });
    document.dispatchEvent(new CustomEvent('facets:load-more', { detail: { count: cards.length } }));
  }

  document.addEventListener('click', (e) => {
    const loadBtn = e.target.closest('[data-fs-root] a[data-load-more]');
    if (loadBtn) {
      e.preventDefault();
      loadMore(loadBtn);
      return;
    }
    const link = e.target.closest('[data-fs-root] a[data-fs-link]');
    if (link) {
      e.preventDefault();
      const url = new URL(link.href, location.origin);
      render(url.search.slice(1));
      return;
    }
    const quick = e.target.closest('[data-fs-price-quick]');
    if (quick) {
      const box = quick.closest('[data-fs-price]');
      const [lo, hi] = quick.dataset.fsPriceQuick.split(',').map((v) => (v === '' ? null : +v));
      setPrice(box, lo, hi);
      render(paramsFromForm());
      return;
    }
    const more = e.target.closest('[data-fs-more]');
    if (more) { toggleMore(more); return; }
    if (e.target.closest('[data-fs-open]')) { setDrawer(true); return; }
    if (e.target.closest('[data-fs-close]')) { setDrawer(false); }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && root()?.classList.contains('is-drawer-open')) setDrawer(false);
  });

  window.addEventListener('popstate', () => {
    if (root()) render(location.search.slice(1), false);
  });

  const init = () => document.querySelectorAll('[data-fs-price]').forEach(paintRange);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
